import { Backdrop } from '@mui/material';
import { SimpleLogo } from '../../../layouts';

export const SuspenseLoader = () => {
  return (
    <Backdrop open={true}>
      <SimpleLogo infinite />
    </Backdrop>
  );
};
